import ThresholdColorLineChart from "component/lineRechart/LineRechart";
import React, { useEffect, useState } from "react";
import styles from "./Usage.module.scss";
import CustomDialog from "component/CustomDialog";
import CalenderModal from "component/calenderModal/CalenderModal";
import DateFilter from "component/dateFilter/DateFilter";
import { DATE_PICKER_VALUE } from "enum/enums";
import { getDate, getLastDate, getNumberOfDays } from "lib/utils";
import { TODAY_DATE, TYPES_OF_GRAPHS } from "lib/Constants";
import { useDispatch } from "react-redux";
import { HANDLE_GET_ANALYTICS } from "store/analytic/action.types";
import { useSelector } from "react-redux";
import LoadingScreen from "component/LoadingScreen";

const Usage = () => {
	const [open, setOpen] = useState(false);
	const [datePickerValue, setDatePickerValue] = useState<DATE_PICKER_VALUE>(DATE_PICKER_VALUE.THIRTY_DAYS);
	const [startDate, setStartDate] = useState<Date>(TODAY_DATE);
	const [endDate, setEndDate] = useState<Date>(TODAY_DATE);
	const { data, loading } = useSelector((state: any) => state.analytic);
	const dispatch = useDispatch();

	const handleShowModal = () => {
		setOpen(!open);
	};

	const handleGetAnalytics = (isCustom = false) => {
		const startD = isCustom ? getDate(startDate) : getLastDate(getNumberOfDays(datePickerValue));
		const endD = isCustom ? getDate(endDate) : getLastDate(1);
		dispatch({
			type: HANDLE_GET_ANALYTICS,
			payload: { startDate: startD, endDate: endD },
		});
	};
	useEffect(() => {
		handleGetAnalytics();
	}, [datePickerValue]);
	return (
		<>
			<div className={`${styles.chart}`}>
				<div className={`${styles.chart__filter} flex justify-end`}>
					<DateFilter
						disabled={false}
						setDatePickerValue={setDatePickerValue}
						datePickerValue={datePickerValue}
						handleShowModal={handleShowModal}
						showStartDate={getDate(startDate)}
						showEndDate={getDate(endDate)}
						startDate={startDate}
						endDate={endDate}
						fetchAllList={() => {
							handleGetAnalytics(true);
						}}
						setStartDate={setStartDate}
						setEndDate={setEndDate}
					/>
				</div>

				{loading ? (
					<div className="flex align-center justify-center h-full">
						<LoadingScreen height={false} />
					</div>
				) : (
					<div className={`${styles.chart__row} `}>
						<div className={`${styles.chart__wrap} flex-wrap`}>
							{Object.entries(data).map(([key, value]: [string, any]) => (
								<div key={key} className={`${styles.chart__main}`}>
									<h2>{TYPES_OF_GRAPHS[key]}</h2>
									<div className={`${styles.chart__box}`}>
										<ThresholdColorLineChart rawData={value} />
									</div>
								</div>
							))}
						</div>
					</div>
				)}
			</div>
			<CustomDialog open={open} handleShowModal={handleShowModal}>
				<CalenderModal
					startDate={startDate}
					setStartDate={setStartDate}
					endDate={endDate}
					setEndDate={setEndDate}
					handleShowModal={handleShowModal}
					setDatePickerValue={setDatePickerValue}
					fetchAllList={() => {
						handleGetAnalytics(true);
					}}
				/>
			</CustomDialog>
		</>
	);
};

export default Usage;
